import CookieDate from './cookie-date';

export default class Cookie extends CookieDate {
    checkCookie() {
        const cn = `${this.cookieName}=`;
        this.acceptedCookie = (document.cookie.indexOf(cn) !== -1);
    }

    cookieWasAccepted() {
        return this.acceptedCookie;
    }

    setCookie() {
        document.cookie = `${this.cookieName}=1; expires=${super.getExpiryDate()}`;
    }

    constructor() {
        super();
        this.cookieName = 'bauzeit_cookie_info_accepted';
        this.checkCookie();
    }
}
